import PropTypes from 'prop-types';
import { default as React } from 'react';
import { FreeMode, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';

const Carrousel = ({
  items,
  slidesPerView = 5,
  spaceBetween = 20,
  navigation = true,
  modules = [FreeMode, Pagination, Navigation],
  slideTag = 'div',
  wrapperTag = 'div',
  ...props
}) => {
  return (
    <Swiper
      slidesPerView={slidesPerView}
      spaceBetween={spaceBetween}
      pagination={{ clickable: true }}
      navigation={navigation}
      modules={modules}
      className="mySwiper"
      wrapperTag={wrapperTag}
      {...props}
    >
      {/* La key de la diapositiva sale de la del elemento (`toArray` la deriva de ella), no del índice: Sonar S6479. */}
      {React.Children.toArray(items).map((item) => (
        <SwiperSlide key={item.key} tag={slideTag}>
          {item}
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

Carrousel.propTypes = {
  items: PropTypes.arrayOf(PropTypes.node).isRequired,
  modules: PropTypes.array,
  navigation: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  slidesPerView: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  slideTag: PropTypes.string,
  spaceBetween: PropTypes.number,
  wrapperTag: PropTypes.string,
};

export default Carrousel;
